import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleTonnageMaster } from "../../../Api/api";

export const addTonnageMasterAsync=createAsyncThunk(
   "tonnageMaster/add",
   async ({ data, done, err }) => {
         try {
            const response = await handleTonnageMaster(data);
            done && done();
            return response.data;
         } catch (error) {
            // You can customize the error handling here
            
            err && err();
            throw error.response.data;
         }
      }
);




